export default __webpack_public_path__ + "static/media/SurfaceTypeCover.71eb6a3f.svg";